/**
 * iter135 — Chats module temporary "Coming Soon" state.
 *
 * Full-screen replacement for the Chats tab while the module is being
 * hidden from hotel owners. Preserves the bottom-nav Chats entry so
 * users see the module is planned. No backend / API / DB change — all
 * conversation ingestion + storage + BFR access keeps running behind
 * the scenes. Toggling back is a 1-line revert in App.js (swap this
 * import for the original ConversationsInboxScreen).
 */
import React from 'react';
import { MessageSquare, Sparkles } from 'lucide-react';
import AppHeader from '../components/AppHeader';

const ConversationsComingSoonScreen = () => (
  <div className="min-h-screen bg-gray-50 pb-24" data-testid="conversations-coming-soon-screen">
    <AppHeader />
    <div className="max-w-lg mx-auto px-6 pt-16">
      <div className="flex flex-col items-center text-center">
        <div className="relative">
          <div className="w-24 h-24 rounded-full bg-[#EEF1FC] flex items-center justify-center">
            <MessageSquare className="w-11 h-11 text-[#1B2A7B]" />
          </div>
          <span className="absolute -top-1 -right-1 w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-amber-600" />
          </span>
        </div>
        <h1 className="mt-6 text-2xl font-bold text-gray-900" data-testid="coming-soon-title">
          Guest Chat — Coming Soon
        </h1>
        <p className="mt-3 text-gray-600 text-sm leading-relaxed max-w-xs">
          We&apos;re polishing the guest conversation experience for you.
          Check back in a few days.
        </p>
      </div>
    </div>
  </div>
);

export default ConversationsComingSoonScreen;
